import { IGetProductsListDTO } from '@/models/products.model';
import { TGetProductsQuery } from '../helpers';

class GetProductsListDTO implements IGetProductsListDTO {
  category?: string;
  name?: string;
  sku?: string;
  external_id?: string;
  store?: string;
  store_ids?: string[];
  category_ids?: string[];
  active?: '0' | '1';
  only_zero_price?: '0' | '1';
  only_without_uktzed?: '0' | '1';
  only_without_dimensions?: '0' | '1';
  limit?: number;
  page?: number;

  constructor({
    category_ids,
    name,
    sku,
    external_id,
    store_ids,
    store,
    page,
    active,
    only_zero_price,
    only_without_uktzed,
    only_without_dimensions,
  }: TGetProductsQuery) {
    this.category_ids = category_ids;
    this.name = name;
    this.sku = sku;
    this.external_id = external_id;
    this.store = store;
    this.store_ids = store_ids;
    this.page = page;
    this.active = active;
    this.only_zero_price = only_zero_price;
    this.only_without_uktzed = only_without_uktzed;
    this.only_without_dimensions = only_without_dimensions;
  }
}

export default GetProductsListDTO;
